// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.grey{\n  background-color: grey;\n}\n/*.vs__search{*/\n/*  padding-top:5px;*/\n/*  padding-bottom:5px;*/\n/*}*/\n", ""]);
// Exports
module.exports = exports;
